export default "__VITE_ASSET__ycD1uRk4__"